import * as Types from 'types/theme';

export default {
  typography: {
    main: "'Avenir Next', sans-serif",
    secondary: "'Lato', sans-serif",
  },
} as Types.Default;
